module.exports = __webpack_public_path__ + "static/img/1.b26e201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tx/1.jpg
// module id = ORD3
// module chunks = 0